import { render, staticRenderFns } from "./ShapeMinigame.vue?vue&type=template&id=134d89ea&scoped=true"
import script from "./ShapeMinigame.vue?vue&type=script&lang=js"
export * from "./ShapeMinigame.vue?vue&type=script&lang=js"
import style0 from "./ShapeMinigame.vue?vue&type=style&index=0&id=134d89ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134d89ea",
  null
  
)

export default component.exports